module.exports = __webpack_public_path__ + "img/05_sub_uk.4ba9779d.svg";